export const ROLE_SUPER_ADMIN = 'Super Admin';
export const ROLE_ADMIN_REGIONAL = 'Admin Regional';
export const ROLE_OPERADOR_REGIONAL = 'Operador Regional';
export const ROLE_EMPRESA = 'Empresa';
